import UserAlertDetails from "../../types/dtos/alert/UserAlertDetails";
import { apiClient } from "../apiClient";

class alertApi {
  constructor(authToken: string | undefined) {
    this.accessToken = authToken;
  }

  accessToken: string | undefined;

  getAlertPanelDataForEmployee(
    onSuccess: (data: UserAlertDetails) => void,
    onError: (error: any) => void
  ) {
    return apiClient(
      this.accessToken,
      "dashboards/notification/get-notification-panel-data-for-employee"
    ).then(
      (data) => {
        onSuccess(data);
      },
      (error) => {
        onError(error);
      }
    );
  }

  markGivenAlertsAsRead(
    returnMostRecentAlertsOnly: boolean,
    alertIds: number[],
    onSuccess: (data: UserAlertDetails) => void,
    onError: (error: any) => void
  ) {
    return apiClient(
      this.accessToken,
      "dashboards/notification/mark-given-notifications-as-read?limitReturnToMostRecent=" + returnMostRecentAlertsOnly,
      {
        body: JSON.stringify(alertIds),
      }
    ).then(
      (data) => {
        onSuccess(data);
      },
      (error) => {
        onError(error);
      }
    );
  }

  markAllAlertsAsRead(
    returnMostRecentAlertsOnly: boolean,
    onSuccess: (data: UserAlertDetails) => void,
    onError: (error: any) => void
  ) {
    return apiClient(
      this.accessToken,
      "dashboards/notification/mark-all-notifications-as-read?limitReturnToMostRecent=" + returnMostRecentAlertsOnly
    ).then(
      (data) => {
        onSuccess(data);
      },
      (error) => {
        onError(error);
      }
    );
  }
}

export default alertApi;
